import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { MDBCardTitle, MDBCardText, MDBBtn, MDBTable,MDBInput, MDBTableHead, MDBTableBody, MDBCard, MDBCardBody } from 'mdb-react-ui-kit';
import '../../../css/index.css';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function ListarCheckin() {

  const api = require('../../../apis/checkin')
  const [usuarios, setUsuarios] = useState([]);
  const [nomeAluno, setNomeAluno] = useState('');
  const utils = require('../../../utils/index');
  const user = utils.getUser();
  const login = true;
  const obj = utils.decideBody(user, login)

  const updateCheckin = async (checkin) => {
    const obj = {
      idLogin: checkin.id,
      idPorteiro: user.id,
      data: utils.getDate()
    }

    try {
      const response = await api.atualizarCheckinApi(obj);
      const data = response;
      data ? toast.success(`Checkin confirmado para ${checkin.aluno}!`) : ""
      }catch (error) {
        console.error('Erro ao obter dados:', error);
    }
  } 




  const navigate = useNavigate();

  const getCheckins = async () => {
    try {
      
      const response = await api.listarCheckinsApi(obj);
      const data = await response;

      

    
      if (Array.isArray(data)) {
        const filteredData = data.filter(usuario => 
          usuario.aluno.toLowerCase().includes(nomeAluno.toLowerCase())
        );
        setUsuarios(filteredData);
      } else {
        console.error('Os dados obtidos não são uma array:', data);
      }
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  useEffect(() => {
    getCheckins( );
  }); 
  
  return (
    <div className="w-100 d-flex align-items-center justify-content-center" style={{height:'100vh'}}>
      <MDBCard className='bg-dark w-75' style={{minWidth:'350px'}}>
        <MDBCardBody className='bg-dark w-100 text-white'>
        <MDBCardTitle className='text-white'>Bem vindo, {utils.decideName(user)}</MDBCardTitle>
          <MDBCardText className='text-white d-flex align-items-center flex-row justify-content-between'>
            O que veio fazer?
                        <MDBInput 
                          wrapperClass='w-25' 
                          labelClass='text-white' 
                          label='Nome do aluno' 
                          name='nomeAluno'
                          id='formControNomeAluno' 
                          type='text' 
                          size="lg"
                          value={nomeAluno}
                          onChange={(e) => setNomeAluno(e.target.value)}
                          style={{color:"white"}}/>
          </MDBCardText>
          <div style={{maxHeight: '500px', overflow: 'auto'}}>
            <MDBTable align='middle' className='text-white '  >
              <MDBTableHead>
                <tr>
                  <th scope='col'>ID</th>
                  <th scope='col'>Nome do aluno</th>
                  <th scope='col'>Código turma</th>
                  <th scope='col'>Nome do responsável</th>
                  <th scope='col'>Matricula do responsável</th>
                  <th scope='col'>Data</th>
                  <th scope='col'>Confirmado</th>
                  {user.tipouser == 6 &&(
                  <th scope='col'>Ações</th>)}
                </tr>
              </MDBTableHead>
              <MDBTableBody >
              {usuarios.map((usuario) => (
                  <tr key={usuario.id}>
                  <td>{usuario.id}</td>
                  <td>{usuario.aluno}</td>
                  <td>{usuario.idturma}</td>
                  <td>{usuario.responsavel}</td>
                  <td>{usuario.idresponsavel}</td>
                  <td>{usuario.data}</td>
                  <td>{usuario.aprovado == 0 ? "Não" : "Sim"}</td>
                  
                  {user.tipouser == 6 &&(
                  <td>
                    
                    <MDBBtn 
                      color='link' 
                      rounded 
                      size='sm'
                      onClick={() => {
                        updateCheckin(usuario)
                      }}
                      >
                      Confirmar
                    </MDBBtn>
                  </td>
                  )}
                </tr>
              ))}
              </MDBTableBody>
            </MDBTable>
          </div>
          <MDBBtn 
              className='btn-home w-100 mt-4'
              size='sm'
              outline 
              color='white' 
              onClick={() => {
                navigate("/area-checkin")
              }}
              >Voltar</MDBBtn>
        </MDBCardBody>
      </MDBCard>
    </div>
  );
}

export default ListarCheckin;